const mapTemplateGroupToOption = group => ({
    value: group.id,
    label: group.name,
});

export default mapTemplateGroupToOption;
